import ApiService from '@/services/common/api.service';
import Utils from '@/helpers/utils';
import _ from 'lodash';

const InfosManagementService = {
    // listInfos,
    getInfo,
    setInfo
};

async function getInfo (params = {}) {
    let url = '/infos';

    if (!Utils.isEmptyObj(params)) {
        let httpBuildQuery = require('http-build-query');
        url += "?" + httpBuildQuery(params);
    }

    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function setInfo (infos) {
    let url = '/infos'

    try {
        let response = await ApiService.post(url, infos);
        return response;
    } catch (error) {
        return error;
    }
}

// /*
//     List Infos
// */
// async function listInfos (page) {
//     let url = '/Infos';

//     let query = {};

//     if (page) {
//         query.page = page;
//         query.pageSize = Constants.ItemPerpage;
//     }

//     if (Utils.isEmptyObj(query) == false) {
//         let httpBuildQuery = require('http-build-query');
//         url += "?" + httpBuildQuery(query);
//     }

//     try {
//         let response = await ApiService.get(url);
//         return response;
//     } catch (error) {
//         return error;
//     }
// }

export default InfosManagementService;



// WEBPACK FOOTER //
// ./src/services/admin/infos.service.js